export default __webpack_public_path__ + "static/media/logo.5e6f96a8.webp";